export default "__VITE_ASSET__BnlzzGqY__"